module.exports = __webpack_public_path__ + "img/exhibits5.7df6c1e0.png";